module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8a460ce856fa81bc6e7f2886cb6a0e1c.png";